import { jsx as _jsx } from "react/jsx-runtime";
import { matchPath, useLocation } from 'react-router-dom';
import Upsell from './components/Upsell';
import { Position } from './types';
export function DashboardTinyUpseller() {
    return _jsx(Upsell, { position: Position.DashboardTinyUpseller });
}
export function DashboardNotificationBar() {
    return _jsx(Upsell, { position: Position.DashboardNotificationBar });
}
export function FloatingUpsell() {
    const location = useLocation();
    const allowedPaths = [
        '/projects/my',
        '/projects/team',
        '/projects/personal',
        '/archive/my',
        '/archive/team',
        '/company/people/members',
        '/company/people/guests',
        '/company/settings',
        '/user/account/personal',
        '/user/account/apps',
    ];
    const isAllowed = allowedPaths
        .map((path) => {
        return !!matchPath(location.pathname, {
            path,
            exact: true,
        });
    })
        .includes(true);
    return isAllowed ? _jsx(Upsell, { position: Position.Floating }) : null;
}
export function DashboardHintBar() {
    return _jsx(Upsell, { position: Position.DashboardHintBar });
}
export function Webinar() {
    return _jsx(Upsell, { position: Position.DashboardSideBar });
}
export { setViewedPricingPage, setDidDowngrade } from './storage-assist';
